/**
 * Mikolito — Audio Player (wersja audio karty bajki)
 * Vanilla JS, steruje natywnym elementem <audio> wewnątrz [data-audio-player].
 */
(function () {
  'use strict';

  var PLAYBACK_RATES = [1, 1.25, 1.5, 0.75];

  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '0:00';
    var m = Math.floor(seconds / 60);
    var s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');
    return m + ':' + s;
  }

  function initPlayer(root) {
    var audio = root.querySelector('[data-audio-element]');
    var toggleBtn = root.querySelector('[data-audio-toggle]');
    var icon = root.querySelector('[data-audio-icon]');
    var track = root.querySelector('[data-audio-track]');
    var progress = root.querySelector('[data-audio-progress]');
    var thumb = root.querySelector('[data-audio-thumb]');
    var currentLabel = root.querySelector('[data-audio-current]');
    var durationLabel = root.querySelector('[data-audio-duration]');
    var rateBtn = root.querySelector('[data-audio-rate]');

    if (!audio) return; // brak audioSrc — player zostaje w stanie wyłączonym z Liquid

    var rateIndex = 0;

    function setIcon(playing) {
      icon.textContent = playing ? '❚❚' : '▶';
    }

    function updateProgress() {
      var pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
      progress.style.width = pct + '%';
      thumb.style.left = pct + '%';
      currentLabel.textContent = formatTime(audio.currentTime);
    }

    toggleBtn.addEventListener('click', function () {
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () {
      setIcon(true);
    });
    audio.addEventListener('pause', function () {
      setIcon(false);
    });
    audio.addEventListener('ended', function () {
      setIcon(false);
    });
    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('loadedmetadata', function () {
      durationLabel.textContent = formatTime(audio.duration);
    });

    track.addEventListener('click', function (event) {
      if (!audio.duration) return;
      var rect = track.getBoundingClientRect();
      var pct = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
      audio.currentTime = pct * audio.duration;
      updateProgress();
    });

    if (rateBtn) {
      rateBtn.addEventListener('click', function () {
        rateIndex = (rateIndex + 1) % PLAYBACK_RATES.length;
        var rate = PLAYBACK_RATES[rateIndex];
        audio.playbackRate = rate;
        rateBtn.textContent = rate + 'x';
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-audio-player]').forEach(initPlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
